import React from 'react';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { IComponentFieldsGeneral } from '../../../types/types';
import { useMenuDispatcher } from './menuContext';
import MenuTriggerContentWithIcon from './menuTriggerContentWithIcon';
import { HeaderFields } from '../types/navigationItem.types';
import { googleNavClickEvent } from '../../../utils/analytics';
import { topIconMenu } from '../../../constants/analytics.constants';

const LoginLink = ({ fields }: { fields: IComponentFieldsGeneral | undefined }) => {
  const dispatchToProvider = useMenuDispatcher();
  const handleClick = () => {
    dispatchToProvider({ type: 'closeAll' });
  };
  return (
    <li className="navigation__menu-item">
      <RoutableSitecoreLink
        field={fields?.login?.link}
        onClick={() => {
          googleNavClickEvent(topIconMenu, fields?.login?.link?.value?.href, fields?.login?.link?.value?.text);
          handleClick();
        }}
        className="navigation__menu-item__trigger"
      >
        <MenuTriggerContentWithIcon iconField={fields?.login?.icon} textValue={fields?.login?.link?.value?.text} />
      </RoutableSitecoreLink>
    </li>
  );
};

const Login = ({ fields }: { fields: HeaderFields }) => {
  return <LoginLink fields={fields} />;
};

export default Login;
